<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>{{ $t("newsDetailText29") }}</span>
      </div>
      <div style="text-align: center;font-size: 18px;" class="small-title">{{ $t("newsDetailText30") }}</div>
      <div style="text-align: right;font-size: 18px;" class="small-title">
        —— Updated October 28th，2024
      </div>
      <iframe src="https://www.ids2024.com/public/uploads/IDS2024_Tentative_Program_Updated_Oct_28.pdf"
        style="height: 1000px" width="100%"></iframe>
      <div class="small-title">
        {{ $t("newsDetailText31") }}
        <span style="color: #0c70ae; cursor: pointer" @click="downFn">
          {{ $t("newsDetailText32") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    downFn() {
      let href =
        "https://www.ids2024.com/public/uploads/IDS2024_Tentative_Program_Updated_Oct_28.pdf";
      var a = document.createElement("a");
      a.href = href;
      a.download = `IDS2024_Tentative_Program_Updated_Oct_28.pdf`;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
  },
};
</script>

<style scoped>
.big-title {
  margin-bottom: 20px;
}

.title {
  color: #0a9a7a;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

.title::after {
  content: "";
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  width: 90px;
  height: 4px;
  text-align: center;
  background: #0a9a7a;
  position: absolute;
  margin-bottom: -10px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}

.text {
  color: #333;
  text-indent: 2em;
  line-height: 2;
  padding-bottom: 20px;
}

.w-350 {
  width: 350px;
  margin: 0 auto;
  text-indent: 0;
  text-align: center;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/program.vue